/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from 'react'
import {
  getTasks,
  createTask,
  updateTask,
  hideTask,
} from '@services'

const useTask = () => {
  // Busca todas as tarefas (já retorna estruturadas pela matriz de Eisenhower)
  const fetchTasks = () => getTasks()

  // Busca tarefas organizadas pela Matriz de Eisenhower
  const getTasksMatrix = () => getTasks()

  // Cria uma nova tarefa
  const createNewTask = (data) => createTask(data)

  // Atualiza uma tarefa existente
  const updateExistingTask = ({ data, id }) => updateTask(id, data)

  // Deleta uma tarefa (soft delete - marca como invisível)
  const removeTask = (id) => hideTask(id)

  return useMemo(
    () => ({
      getTasks: fetchTasks,
      getTasksMatrix,
      createTask: createNewTask,
      updateTask: updateExistingTask,
      deleteTask: removeTask,
    }),
    []
  )
}

export { useTask }
